// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/NewLogistPage/NewLogistPage.module.css */

/* Основной контейнер */
.NewLogistPage_app__tt\\+qL {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-family: Arial, sans-serif;
}

/* Шапка */
.NewLogistPage_header__FjKxu {
  flex: 0 0 50px;
  background: #2c3e50;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0 16px;
  font-size: 18px;
}

/* Контейнер с тремя колонками */
.NewLogistPage_main__WgvSE {
  flex: 1 1;
  display: flex;
  overflow: hidden;
}

/* Общие стили для боковых панелей */
.NewLogistPage_sidebar__jQVtk {
  flex: 0 0 200px;
  border-right: 1px solid #ddd;
  padding: 16px;
  overflow-y: auto;
  background: #fafafa;
}

/* Список маршрутных листов */
.NewLogistPage_routesList__POV3H {
  list-style: none;
  padding: 0;
  margin: 0;
}
.NewLogistPage_routeItem__R2i23 {
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.NewLogistPage_routeItem__R2i23:hover {
  background: #eef4ff;
}
.NewLogistPage_selectedRoute__FXxfM {
  background: #dceefd;
}
.NewLogistPage_empty__oeQJr {
  color: #777;
  font-style: italic;
  padding: 8px;
}

/* Центральная колонка: таймлайн и карта */
.NewLogistPage_content__m28x4 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Таймлайн */
.NewLogistPage_timeline__3uYjK {
  flex: 0 0 150px;
  border-bottom: 1px solid #ddd;
  display: flex;
  flex-direction: column;
}
.NewLogistPage_timeScale__X2qKu {
  display: flex;
  overflow-x: auto;
  background: #f7f7f7;
  padding: 4px 0;
}
.NewLogistPage_timeScale__X2qKu span {
  flex: 0 0 60px;
  text-align: center;
  font-size: 12px;
  color: #555;
}
.NewLogistPage_timelineBody__Y1\\+T4 {
  flex: 1 1;
  background: #fff;
}

/* Карта */
.NewLogistPage_map__V8M49 {
  flex: 1 1;
  position: relative;
}
.NewLogistPage_mapPlaceholder__5tQFU {
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #777;
  font-size: 24px;
}

/* Правая колонка: список квитанций */
.NewLogistPage_receiptsList__sOXcP {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: calc(100% - 40px); /* учёт заголовка */
  overflow-y: auto;
}

/* Карточка квитанции */
.NewLogistPage_receiptCard__aul\\+3 {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.NewLogistPage_receiptCard__aul\\+3:hover {
  background: #f5faff;
}

/* Шапка карточки квитанции */
.NewLogistPage_rcHeader__-WvA0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.NewLogistPage_rcNumber__Tgb0h {
  font-weight: bold;
}
.NewLogistPage_rcStatus__24gI9 {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
}
/* Цвета статусов */
.NewLogistPage_status_Закрыта__c4BWo    { background-color: #28a745; }
.NewLogistPage_status_Открыта__QfCov    { background-color: #007bff; }
.NewLogistPage_status_Недоставлено__7GKf9 { background-color: #dc3545; }
.NewLogistPage_status_Вобработке__FFG4X { background-color: #ffc107; }

/* Тело карточки квитанции */
.NewLogistPage_rcBody__IiL7L {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.NewLogistPage_rcField__vsalX {
  font-size: 13px;
}

/* src/pages/NewLogistPage/NewLogistPage.module.css */

/* ---- шапка ---- */
.NewLogistPage_header__FjKxu {
  flex: 0 0 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  background: #2c3e50;
  color: white;
}
.NewLogistPage_dateFilter__CIoJt label {
  margin-left: 12px;
  font-size: 14px;
  color: #eee;
}
.NewLogistPage_dateFilter__CIoJt input {
  margin-left: 4px;
}

/* ---- центральная карта ---- */
.NewLogistPage_mapSection__4Dfc- {
  flex: 1 1;
  position: relative;
}
.NewLogistPage_map__V8M49 {
  width: 100%;
  height: 100%;
}
.NewLogistPage_mapPlaceholder__5tQFU {
  width: 100%;
  height: 100%;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #777;
  font-size: 24px;
}

/* Общие стили боковых панелей, список маршрутов и карточек оставляем те же */

/* Убедитесь, что .main растягивается на всю высоту: */
.NewLogistPage_main__WgvSE {
  flex: 1 1;
  display: flex;
  height: calc(100% - 60px);
}
`, "",{"version":3,"sources":["webpack://./src/modules/Logist/NewLogistPage/NewLogistPage.module.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,SAAO;EACP,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM,EAAE,QAAQ,EAAE,SAAS,EAAE,OAAO;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,6BAA6B,EAAE,mBAAmB;EAClD,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA,mBAAmB;AACnB,0CAAqB,yBAAyB,EAAE;AAChD,0CAAqB,yBAAyB,EAAE;AAChD,4CAAuB,yBAAyB,EAAE;AAClD,0CAAqB,yBAAyB,EAAE;;AAEhD,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;;AAEA,qDAAqD;;AAErD,oBAAoB;AACpB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,SAAO;EACP,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA,6EAA6E;;AAE7E,sDAAsD;AACtD;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":["/* src/pages/NewLogistPage/NewLogistPage.module.css */\r\n\r\n/* Основной контейнер */\r\n.app {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n/* Шапка */\r\n.header {\r\n  flex: 0 0 50px;\r\n  background: #2c3e50;\r\n  color: #fff;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 16px;\r\n  font-size: 18px;\r\n}\r\n\r\n/* Контейнер с тремя колонками */\r\n.main {\r\n  flex: 1;\r\n  display: flex;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Общие стили для боковых панелей */\r\n.sidebar {\r\n  flex: 0 0 200px;\r\n  border-right: 1px solid #ddd;\r\n  padding: 16px;\r\n  overflow-y: auto;\r\n  background: #fafafa;\r\n}\r\n\r\n/* Список маршрутных листов */\r\n.routesList {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.routeItem {\r\n  padding: 8px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  transition: background-color 0.2s;\r\n}\r\n.routeItem:hover {\r\n  background: #eef4ff;\r\n}\r\n.selectedRoute {\r\n  background: #dceefd;\r\n}\r\n.empty {\r\n  color: #777;\r\n  font-style: italic;\r\n  padding: 8px;\r\n}\r\n\r\n/* Центральная колонка: таймлайн и карта */\r\n.content {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Таймлайн */\r\n.timeline {\r\n  flex: 0 0 150px;\r\n  border-bottom: 1px solid #ddd;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.timeScale {\r\n  display: flex;\r\n  overflow-x: auto;\r\n  background: #f7f7f7;\r\n  padding: 4px 0;\r\n}\r\n.timeScale span {\r\n  flex: 0 0 60px;\r\n  text-align: center;\r\n  font-size: 12px;\r\n  color: #555;\r\n}\r\n.timelineBody {\r\n  flex: 1;\r\n  background: #fff;\r\n}\r\n\r\n/* Карта */\r\n.map {\r\n  flex: 1;\r\n  position: relative;\r\n}\r\n.mapPlaceholder {\r\n  position: absolute;\r\n  top: 0; right: 0; bottom: 0; left: 0;\r\n  background: #e0e0e0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #777;\r\n  font-size: 24px;\r\n}\r\n\r\n/* Правая колонка: список квитанций */\r\n.receiptsList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  max-height: calc(100% - 40px); /* учёт заголовка */\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Карточка квитанции */\r\n.receiptCard {\r\n  background: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  padding: 8px 12px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n.receiptCard:hover {\r\n  background: #f5faff;\r\n}\r\n\r\n/* Шапка карточки квитанции */\r\n.rcHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rcNumber {\r\n  font-weight: bold;\r\n}\r\n.rcStatus {\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  color: #fff;\r\n}\r\n/* Цвета статусов */\r\n.status_Закрыта    { background-color: #28a745; }\r\n.status_Открыта    { background-color: #007bff; }\r\n.status_Недоставлено { background-color: #dc3545; }\r\n.status_Вобработке { background-color: #ffc107; }\r\n\r\n/* Тело карточки квитанции */\r\n.rcBody {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n.rcField {\r\n  font-size: 13px;\r\n}\r\n\r\n/* src/pages/NewLogistPage/NewLogistPage.module.css */\r\n\r\n/* ---- шапка ---- */\r\n.header {\r\n  flex: 0 0 60px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 16px;\r\n  background: #2c3e50;\r\n  color: white;\r\n}\r\n.dateFilter label {\r\n  margin-left: 12px;\r\n  font-size: 14px;\r\n  color: #eee;\r\n}\r\n.dateFilter input {\r\n  margin-left: 4px;\r\n}\r\n\r\n/* ---- центральная карта ---- */\r\n.mapSection {\r\n  flex: 1;\r\n  position: relative;\r\n}\r\n.map {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.mapPlaceholder {\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #e0e0e0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #777;\r\n  font-size: 24px;\r\n}\r\n\r\n/* Общие стили боковых панелей, список маршрутов и карточек оставляем те же */\r\n\r\n/* Убедитесь, что .main растягивается на всю высоту: */\r\n.main {\r\n  flex: 1;\r\n  display: flex;\r\n  height: calc(100% - 60px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": `NewLogistPage_app__tt+qL`,
	"header": `NewLogistPage_header__FjKxu`,
	"main": `NewLogistPage_main__WgvSE`,
	"sidebar": `NewLogistPage_sidebar__jQVtk`,
	"routesList": `NewLogistPage_routesList__POV3H`,
	"routeItem": `NewLogistPage_routeItem__R2i23`,
	"selectedRoute": `NewLogistPage_selectedRoute__FXxfM`,
	"empty": `NewLogistPage_empty__oeQJr`,
	"content": `NewLogistPage_content__m28x4`,
	"timeline": `NewLogistPage_timeline__3uYjK`,
	"timeScale": `NewLogistPage_timeScale__X2qKu`,
	"timelineBody": `NewLogistPage_timelineBody__Y1+T4`,
	"map": `NewLogistPage_map__V8M49`,
	"mapPlaceholder": `NewLogistPage_mapPlaceholder__5tQFU`,
	"receiptsList": `NewLogistPage_receiptsList__sOXcP`,
	"receiptCard": `NewLogistPage_receiptCard__aul+3`,
	"rcHeader": `NewLogistPage_rcHeader__-WvA0`,
	"rcNumber": `NewLogistPage_rcNumber__Tgb0h`,
	"rcStatus": `NewLogistPage_rcStatus__24gI9`,
	"status_Закрыта": `NewLogistPage_status_Закрыта__c4BWo`,
	"status_Открыта": `NewLogistPage_status_Открыта__QfCov`,
	"status_Недоставлено": `NewLogistPage_status_Недоставлено__7GKf9`,
	"status_Вобработке": `NewLogistPage_status_Вобработке__FFG4X`,
	"rcBody": `NewLogistPage_rcBody__IiL7L`,
	"rcField": `NewLogistPage_rcField__vsalX`,
	"dateFilter": `NewLogistPage_dateFilter__CIoJt`,
	"mapSection": `NewLogistPage_mapSection__4Dfc-`
};
export default ___CSS_LOADER_EXPORT___;
